export default __webpack_public_path__ + "static/media/61.8e3298bb.jpeg";